<template>
    <div>
        <el-dialog
                width="400px"
                :visible.sync="visible"
                :show-close="false"
                :close-on-click-modal="false"
        >

            <div slot="title">
                <z-title :title="(type==0?'新增':'编辑')+'提成规则'"></z-title>
            </div>
            <el-form :model="info" :rules="rules" ref="ruleForm" class="rulefrom" label-width="80px">
                <el-form-item label="提成名称" prop="commissionTitle" :show-message="false">
                    <el-input maxlength="16" v-model="info.commissionTitle" placeholder="请输入提成名称"></el-input>
                </el-form-item>
                <el-form-item label="订单类型" prop="orderCategory"  :show-message="false">
                    <el-select v-model="info.orderCategory" placeholder="请选择订单类型">
                        <el-option
                                v-for="item,index in orderCategoryList"
                                :key="item.dicCode"
                                :label="item.dicName"
                                :value="item.dicCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="提成规则" v-if="info.orderCategory" prop="commissionType" :show-message="false">
                    <el-select v-model="info.commissionType" placeholder="请选择提成规则" value-key="commissionTypeCode">
                        <el-option
                                v-for="item,index in commissionTypeList"
                                :key="item.commissionTypeCode"
                                :label="item.commissionName"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="金 额" v-if="info.commissionType.commissionValueType=='1'" prop="commissionValue"  :show-message="false">
                    <el-input maxlength="16" v-model="info.commissionValue" placeholder="请输入金额"></el-input>
                </el-form-item>
                <el-form-item label="收款比例" v-if="info.commissionType.commissionValueType=='2'" prop="commissionValue"  :show-message="false">
                    <div class="flex-n fac">
                    <el-input maxlength="16" v-model="info.commissionValue" placeholder="请输入收款比例"></el-input>
                        <div class="ml-10">%</div>
                    </div>
                </el-form-item>
                <el-form-item label="默认提成" prop="isDefault"  :show-message="false">
                    <el-radio-group v-model="info.isDefault">
                        <el-radio label="1">开</el-radio>
                        <el-radio label="0">关</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item class="mt-10 flex-n fje">
                    <el-button type="primary" @click="submitForm('ruleForm')"  :loading="loading">保 存</el-button>
                    <el-button @click="resetForm">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import ZTitle from "../../../components/ZTitle";

    export default {
        components: {ZTitle},
        name: "edit-commission",
        props:{
            visible:Boolean,
            type:Number|String,
            id:String
        },
        data(){
            return{
                loading:false,
                orderCategoryList:[],
                commissionTypeList:[],
                info:{
                    "commissionTitle": "",
                    "orderCategory": "",
                    "commissionValue": "",
                    "commissionType": {},
                    "isDefault": "1"
                },
                rules: {
                    "commissionTitle": [{required: true, message: '不能为空', trigger: 'blur'}],
                    "orderCategory": [{required: true, message: '不能为空', trigger: 'blur'}],
                    "commissionValue": [{required: true, message: '不能为空', trigger: 'blur'}],
                    "commissionType":[{required: true, message: '不能为空', trigger: 'blur'}],
                    "isDefault":[{required: true, message: '不能为空', trigger: 'blur'}]
                },
            }
        },
        watch:{
            visible(newval,oldval){
                if(newval){
                    if(this.type==1){
                        this.loading=true;
                        this.getData();
                    }
                    this.getOrderCategory();
                }
            },
            'info.orderCategory'(newval,oldval){
                if(newval){
                    this.getCommissionTypeList();
                }
            }
        },
        methods:{
            getData(){
                this.$axios.get('/orderCommissionConfig/commissionDetail/'+this.id).then(res=>{
                    console.log('提成规则',res.data)
                    this.loading=false;
                    var info=res.data;


                    this.info={
                        "commissionTitle":info.commissionTitle,
                        "orderCategory": info.orderCategory,
                        "commissionValue": info.commissionValue,
                        "commissionType": {
                            commissionTypeCode:info.commissionType,
                            commissionValueType:info.commissionValueType
                        },
                        "isDefault": info.isDefault
                    };
                    console.log(this.info)
                }).catch(err=>{
                    this.loading=false;
                    this.$message.error(err.msg);
                })
            },
            //订单类型
            getOrderCategory(){
                if(this.$root.getStorage('dic')){
                    this.orderCategoryList=this.$root.getStorage('dic').filter((item)=>item.dicType=='order_category');
                }else{
                    this.$store.state.dicChange=true;
                }
            },
            //提成规则
            getCommissionTypeList(){
                this.$axios.post('orderCommissionType/commissionTypeList',{
                    orderCategory:this.info.orderCategory
                }).then(res=>{
                    this.commissionTypeList=res.data.list;
                    console.log(res)
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            addCommission(){
                var info=this.info;
                this.$axios.post('/orderCommissionConfig/commissionAdd',{
                    storeId: this.$root.getStorage('storeId'),
                    "commissionTitle":info.commissionTitle,
                    "orderCategory": info.orderCategory,
                    "commissionValue":(info.commissionType.commissionTypeCode==1||info.commissionType.commissionTypeCode==2)?info.commissionValue:0,
                    "commissionType": info.commissionType.commissionTypeCode,
                    "isDefault":info.isDefault
                }).then(res=>{
                    this.$message.success('新增提成规则成功！');
                    this.resetForm();
                }).catch(err=>{
                    this.loading=false;
                    this.$message.error(err.msg);
                })
            },
            editCommission(){
                var info=this.info;
                this.$axios.post('/orderCommissionConfig/commissionUpdate',{
                    id:this.id,
                    storeId: this.$root.getStorage('storeId'),
                    "commissionTitle":info.commissionTitle,
                    "orderCategory": info.orderCategory,
                    "commissionValue":(info.commissionType.commissionTypeCode==1||info.commissionType.commissionTypeCode==2)?info.commissionValue:0,
                    "commissionType": info.commissionType.commissionTypeCode,
                    "isDefault":info.isDefault
                }).then(res=>{
                    this.$message.success('编辑提成规则成功！');
                    this.resetForm();
                }).catch(err=>{
                    this.loading=false;
                    this.$message.error(err.msg);
                })
            },
            submitForm(formName) {
                this.loading=true;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.type==0){
                            this.addCommission();
                        }else{
                            this.editCommission();
                        }
                    } else {
                        this.$message.error('表单填写有误');
                        this.loading=false;
                        return false;
                    }
                });
            },

            resetForm(){
                this.loading=false;
                this.$emit('refresh');
                this.$refs.ruleForm.resetFields();
                this.$emit('update:visible', false)
            },
        }
    }
</script>

<style scoped>

</style>